import React from 'react'
import GigStartConfirmModal from '../GigStartConfirmModal'
import GigEndConfirmModal from '../GigEndConfirmModal'
import SlidesRemoveConfirmModal from '../SlidesRemoveConfirmModal'
import GoingLiveModal from '../GoingLiveModal'
import RescheduledModal from '../RescheduledModal'
import SettingsModal from '../SettingsModal'
import DeadMansHandleContent from '../DeadMansHandleContent'
import ReconnectionModal from '../ReconnectionModal'
import PlayInUploadModal from '../PlayInUploadModal'
import { status as statuses } from '@bt-react/constants'
import SlidesUploadModal from '../SlidesUploadModal'
import LiveEnabledModal from '../LiveEnabledModal'
import StreamModal from '../EventStreaming/StreamModal'
import { PresenterModalManagerProps, PresenterModalManagerState, Location } from './types'

class PresenterModalManager extends React.Component<PresenterModalManagerProps, PresenterModalManagerState> {

  constructor (props) {

    super(props)
    this.state = {
      goingLiveCompleted: false
    }

  }

  handleGoingLiveCompletion = () => {

    this.setState({ goingLiveCompleted: true })

  }

  getPage = (location: Location) => {

    const routes = /messageCenter|end|watch|present/g
    return location.pathname.match(routes) || 'access'

  }

  render () {

    const {
      status,
      isDeadMansHandleOpen,
      showLiveEnabledModal,
      showGoingLiveModal,
      showRescheduledModal,
      showSettingsModal,
      showReconnectingModal,
      showPlayInModal,
      showSlidesUploadModal,
      showSlidesRemoveConfirmModal,
      showGigStartConfirmationModal,
      showGigEndConfirmationModal,
      showStreamModal
    } = this.props

    const isAccessPage = this.getPage(this.props.location) === 'access'

    return <>
      {
        showLiveEnabledModal && !isAccessPage && <LiveEnabledModal />
      }
      {
        showGigStartConfirmationModal &&
        <GigStartConfirmModal />
      }
      {
        showGigEndConfirmationModal &&
        <GigEndConfirmModal />
      }
      {
        status === statuses.OVERRUN && isDeadMansHandleOpen && !isAccessPage &&
        <DeadMansHandleContent />
      }
      {
        showGoingLiveModal &&
        !this.state.goingLiveCompleted &&
        <GoingLiveModal onComplete={this.handleGoingLiveCompletion} />
      }
      {
        showRescheduledModal &&
        <RescheduledModal />
      }
      {
        showSettingsModal &&
        <SettingsModal />
      }
      {
        showReconnectingModal &&
        <ReconnectionModal />
      }
      {
        showPlayInModal &&
        <PlayInUploadModal />
      }
      {
        showSlidesUploadModal &&
        <SlidesUploadModal />
      }
      {
        showSlidesRemoveConfirmModal &&
        <SlidesRemoveConfirmModal />
      }
      {
        showStreamModal &&
        <StreamModal />
      }
    </>

  }

}

export default PresenterModalManager
